module.exports = __webpack_public_path__ + "static/media/image.2bb30613.svg";